module.exports = __webpack_public_path__ + "img/img-treinamento.b8bcfd7c.svg";